import app from '@/app';

/* @ngInject */
function Noise($resource) {
	return $resource(
		'api/noises/:id',
		{ id: '@id' },
		{
			query: { method: 'GET' },
			purge: { method: 'DELETE' }
		}
	);
}

app.factory('Noise', Noise);
